module.exports = __webpack_public_path__ + "static/Landing_Illustration-04.4a8607a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landing_Illustration-04.png
// module id = 60
// module chunks = 35783957827783 40787343088564